/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ColorsDTO
 */
export interface ColorsDTO {
    /**
     * 
     * @type {string}
     * @memberof ColorsDTO
     */
    color: string;
    /**
     * 
     * @type {string}
     * @memberof ColorsDTO
     */
    owner: string;
}

/**
 * Check if a given object implements the ColorsDTO interface.
 */
export function instanceOfColorsDTO(value: object): value is ColorsDTO {
    if (!('color' in value) || value['color'] === undefined) return false;
    if (!('owner' in value) || value['owner'] === undefined) return false;
    return true;
}

export function ColorsDTOFromJSON(json: any): ColorsDTO {
    return ColorsDTOFromJSONTyped(json, false);
}

export function ColorsDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ColorsDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'color': json['color'],
        'owner': json['owner'],
    };
}

export function ColorsDTOToJSON(value?: ColorsDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'color': value['color'],
        'owner': value['owner'],
    };
}

